import styled from 'styled-components/macro';

import { DropdownSelect } from '../../common/formElements';
import { PopupTextArea } from '../Popups.styles';

export const DropdownReason = styled(DropdownSelect)`
  margin-bottom: 16px;
`;

export const PopupTextAreaCancellationNote = styled(PopupTextArea)`
  min-height: 150px;
`;
